import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import Landing from './pages/Landing.jsx';
import Login from './pages/Login.jsx';
import Dashboard from './pages/Dashboard.jsx';
import AgentsDashboard from './pages/AgentsDashboard.jsx';
import CaseStudyPage from './pages/CaseStudyPage.jsx';
import DemoSimulator from './pages/DemoSimulator.jsx';
import Blog from './pages/Blog.jsx';
import BlogPost from './pages/BlogPost.jsx';
import TBSDashboard from './pages/TBSDashboard.jsx';
import WarehouseOrdering from './pages/WarehouseOrdering.jsx';
import WarehouseAgentDashboard from './pages/WarehouseAgentDashboard.jsx';
import Integrations from './pages/Integrations.jsx';
import IntegrationSetup from './pages/IntegrationSetup.jsx';
import { AuthProvider } from './context/AuthContext.jsx';
import { BusinessProvider } from './context/BusinessContext.jsx';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <BusinessProvider>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/agents" element={<AgentsDashboard />} />
              <Route path="/case-study" element={<CaseStudyPage />} />
              <Route path="/demo" element={<DemoSimulator />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/tbs-dashboard" element={<TBSDashboard />} />
              <Route path="/tbs-dashboard/warehouse-ordering" element={<WarehouseOrdering />} />
              <Route path="/tbs-dashboard/warehouse-agent" element={<WarehouseAgentDashboard />} />
              <Route path="/dashboard/integrations" element={<Integrations />} />
              <Route path="/dashboard/integrations/setup" element={<IntegrationSetup />} />
            </Routes>
            <Toaster position="top-right" theme="dark" />
          </BusinessProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
